import i18n from '@i18next/i18n';
import BLANK_GROUP_ICON from '@tencent/docs-design-resources/image/desktop/png@3x/blankpage/blankpage_group_160@3x.png';
import Button from '@tencent/dui/lib/components/Button';
import React from 'react';
import { CommentGroupInfoMap, IAddCommentGroup } from '../../../base/index.interface';
import { PendingCommentGroup } from '../../../type';
import Style from '../index.less';
import classNames from 'classnames';

export interface IEmptyCommentDrawerProps {
    isAddCommentDisabled?: boolean;
    isJumpBtnDisabled?: boolean;
    addCommentGroup: () => IAddCommentGroup | undefined;
    jumpToNextComment(): void;
    updateCommentDrawerProps(props: {
        commentGroupInfoMap: CommentGroupInfoMap,
        pendingCommentGroup: PendingCommentGroup,
    }): void;
}

const CommentDrawerEmpty: React.FC<IEmptyCommentDrawerProps> = (props: IEmptyCommentDrawerProps) => {
    const addComment = () => {
        const commentDrawerProps = props.addCommentGroup();
        if (!commentDrawerProps) return;
        props.updateCommentDrawerProps(commentDrawerProps);
    };

    const addBtnClass = classNames({
        [Style.button]: true,
        [Style['button-disabled']]: props.isAddCommentDisabled,
    });

    const jumpBtnClass = classNames({
        [Style.button]: true,
        [Style['button-disabled']]: props.isJumpBtnDisabled,
    });

    return <div className={Style['empty-comment']}>
        <img src={BLANK_GROUP_ICON} alt='' className={Style['blank-group-icon']}></img>
        <div className={Style.title}>{i18n.t('此页暂无批注')}</div>
        <div className={Style['button-wrapper']}>
            <Button
                className={addBtnClass}
                style={{ marginRight: 10 }}
                size='small'
                type='plain'
                onClick={addComment}
            >
                {i18n.t('添加批注')}
            </Button>
            <Button
                className={jumpBtnClass}
                size='small'
                type='plain'
                onClick={props.jumpToNextComment}
            >
                {i18n.t('下一条批注')}
            </Button>
        </div>
    </div>;
};

export default CommentDrawerEmpty;
